/**
 * @generated SignedSource<<4c1f9fda37e1e30a55cd614f5bc87653>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
export type TemplateCategoryEnum = "SURGERY" | "TURNOVER";
import { FragmentRefs } from "relay-runtime";
export type TimerContentUpdateInputFragment$data = {
  readonly id: string | null | undefined;
  readonly status: JobStatusEnum | null | undefined;
  readonly template: {
    readonly category: TemplateCategoryEnum | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "TimerContentUpdateInputFragment";
};
export type TimerContentUpdateInputFragment$key = {
  readonly " $data"?: TimerContentUpdateInputFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentUpdateInputFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimerContentUpdateInputFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Template",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node as any).hash = "13de4b25a27f9619ac2b16d78fed887f";

export default node;
